import { observable } from 'mobx'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import Validators from '../validators'
import subentityConfs from './subentity'
import { BaseManipStateFn, BaseTableState } from '../base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    requiredOptions = [
      'FlyPrivatePlatforms',
      'FlyPrivatePlatformsAuth0',
      'TestingGroups',
      'PricingTiers',
      'VodSaleTypes',
      linkConst.LOAD_OPTIONS.films,
      linkConst.LOAD_OPTIONS.flyprivate_pricings,
      ['flyprivate_testing',
        '/flyprivate_testing?attrs=["id","tester_id","tester_email","tester_group","platform","platform_auth0"]',
        'tester_email'
      ]
    ]

    @observable userTransactions = []
    createtitle = store.__(linkConst.LINK_FPVTESTING_TITLE).concat(defaultConst.TITLE_DIVIDER) +
      store.__(defaultConst.TITLE_CREATE)

    edittitle = store.__(linkConst.LINK_FPVTESTING_TITLE).concat(defaultConst.TITLE_DIVIDER) +
      store.__(defaultConst.TITLE_EDIT)

    subentities = subentityConfs(store)
    subList = [
      // beware, order is important!
      'flyprivate_testing_films',
      'flyprivate_testing_tiers'
    ]

    validators = {
      tester_id: Validators.isMandatory(store),
      platform_auth0: Validators.isMandatory(store),
      platform: Validators.isMandatory(store),
      _global: (vals) => {
        const items = store.options.get('flyprivate_testing')
        const existing = vals.has('tester_id') && items && items.find((i) => (
          i.tester_id === vals.get('tester_id') && (
            (typeof i.id === 'undefined' && vals.has('id')) ||
            (i.id && i.id !== vals.get('id')) ||
            (i.control_timestamp && vals.has('control_timestamp') &&
              i.control_timestamp !== vals.get('control_timestamp')))
        ))

        if (store.cv.isEntityChanged || store.working) {
          this.subList.map(val => {
            vals.get(val).map(item => {
              this.addParams(val, item)
            })
          })
        }

        return existing
          ? [store.__('Warning, "Auth0 ID" must be unique.')]
          : undefined
      }
    }

    prepareNew () {
      this.subList.map(i => this.record.set(i, []))
    }

    addParams (val, item) {
      const addParam = (val === this.subList[0] ? 'slug' : 'tier')
      if (!item[addParam]) {
        const found = store.options.get(
          addParam === 'slug' ? 'films' : 'flyprivate_pricings').find(
          i => i.id === item[addParam === 'slug' ? 'film_id' : 'tier_id']
        )
        item[addParam] = found && found[addParam]
      }
    }

    loadTransactions (entity) {
      const testerID = entity.tester_id || entity.get('tester_id')
      const platformAuth0 = entity.platform_auth0 || entity.get('platform_auth0')
      const userTransactions = store.cv.userTransactions && Object.keys(store.cv.userTransactions).join()

      if (testerID && platformAuth0) {
        store.workingUpdate(true)
        return store.requester.call(`/nosqldb/dynamodb/?tester_id=${testerID}&platform_auth0=${platformAuth0}`)
          .then((result) => {
            store.workingUpdate(false)
            store.cv.userTransactions = result.data
            return (!userTransactions && result.data) ||
            (result.data && userTransactions && userTransactions !== Object.keys(result.data).join())
          }).catch(store.onRequesterError.bind(store))
      } else {
        return false
      }
    }

    onLoaded (entity) {
      this.subList.map(val => {
        entity[val].map(item => {
          this.addParams(val, item)
        })
      })
      this.loadTransactions(entity)
      super.onLoaded(entity)
    }

    onSaved (saved) {
      this.loadTransactions(saved)
      return super.onSaved(saved)
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'tester_id', 'tester_group', 'platform_auth0', 'tester_email', 'tester_name'
    ]

    headertitles = [
      store.__('ID'), store.__('auth0 ID'), store.__('group'), store.__('Auth0 platform'), store.__('e-mail'), store.__('name')
    ]

    title = store.__(linkConst.LINK_FPVTESTING_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_FPVTESTING]

    requiredOptions = [
      'FlyPrivatePlatformsAuth0', 'TestingGroups'
    ]
  }

  return {
    ManipState,
    TableState
  }
}
